<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Empresas</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Nova" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>
						<Button type="button" icon="pi pi-pencil" label="Editar período de fechamento" class="p-mr-2" @click="editarPeridoFechamento" v-if="permissaoEditar"/>										
					</template>
					
				</Toolbar>

				<DataTable :value="cnpjs"  :autoLayout="true"  :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">	
							<div class="p-d-flex p-jc-between">
								<h5 class="p-m-0">Período de fechamento: {{ diaInicioFechamento }} a {{ diaFinalFechamento }}</h5>					
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="numero" header="CNPJ/CPF" sortable>
						<template #body="slotProps">
							<label v-if="slotProps.data.tipoNumeroDocumento == 'cnpj'">
								{{ slotProps.data.numero | maskCNPJ }}
							</label>
							<label v-else>
								{{ slotProps.data.numero | maskCPF }}
							</label>							
						</template>
					</Column>
					<Column field="razaoSocial" header="Razão Social" sortable></Column>
					<Column field="celular" header="Celular" sortable>
						<template #body="slotProps">
							{{ slotProps.data.celular | maskTelefone }}
						</template>
					</Column>
					<Column field="telefone1" header="Telefone 1" sortable>
						<template #body="slotProps">
							{{ slotProps.data.telefone1 | maskTelefone }}
						</template>	
					</Column>
					<Column field="telefone2" header="Telefone 2" sortable>
						<template #body="slotProps">
							{{ slotProps.data.telefone2 | maskTelefone }}
						</template>
					</Column>	
					<Column field="codigoContabil" header="Código Contábil" sortable></Column>	
					<Column field="estado" header="Estado" sortable></Column>	
					<Column field="cidade" header="Cidade" sortable></Column>				
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>							
						</template>
					</Column>
				</DataTable>

				<Dialog :visible.sync="exibirDialogPeriodoFechamento" header="Editar período de fechamento" :modal="true" class="p-fluid" :style="{width: '450px'}">	
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col">
							<label for="dIni">Dia início</label>							
							<Dropdown id="dIni" v-model.number="empresa.diaInicioFechamento"
								:options="diasInicio" optionLabel="id" optionValue="dia" appendTo="body"/>				
						</div>
						<div class="p-field p-col">
							<label for="dFin">Dia final</label>
							<Dropdown id="dFin" v-model.number="empresa.diaFinalFechamento"
								:options="diasFinal" optionLabel="id" optionValue="dia" appendTo="body"/>
						</div>
					</div>						
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogPeriodoFechamento = false"/>
						<Button label="Salvar" icon="pi pi-check" @click="alterarPeriodoFechamento" />
					</template>
				</Dialog>		

			</div>
		</div>
	</div>
</template>

<script>
import EmpresaService from '@/service/EmpresaService';
import Cnpj from '@/model/Cnpj';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
	empresaService: null,
	data() {
		return {	
			exibirDialogPeriodoFechamento: false,
			permissaoNovo: false,
			permissaoEditar: false,		
			tituloModal: 'Novo CNPJ',			
			exibirDialogCadastro: false,		
			enviandoForm: false,	
			diaInicioFechamento: 1,
			diaFinalFechamento: 31,	
			cnpj: new Cnpj(),	
			cnpjs: [],		
			diasInicio: [],
			diasFinal: [],
			empresa: {},
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),	
		...mapActions('sessao', ['atualizarPeriodoFechamento']),
		listar(){
			this.empresaService.listar({...this.getDadosRequisicao()})
				.then(resp => {			
					this.cnpjs = resp.data.cnpjs;								
					let emp = resp.data;
					emp.cnpjs = [];					
					this.diaInicioFechamento = emp.diaInicioFechamento;
					this.diaFinalFechamento = emp.diaFinalFechamento;					
                })
                .catch(erro => {exibirMensagem(this, erro)});

		},
		novo() {
			this.$router.push('/cadastros/empresas/nova');
		},
		editar(cnpj) {
			this.$router.push('/cadastros/empresas/'+cnpj.id+'/editar');
		},
		editarPeridoFechamento() {
			if(this.diasInicio.length == 0) {
				for(let i = 1; i < 32; i++) {
					this.diasInicio.push({id:i, dia:i});
					this.diasFinal.push({id:i, dia:i});
				}
			}
			this.empresaService.buscarEmpresaPrincipal({...this.getDadosRequisicao()})
				.then(resp => {			
					this.empresa = resp.data;	
					this.exibirDialogPeriodoFechamento = true;
                })
                .catch(erro => {exibirMensagem(this, erro)});			
		},
		alterarPeriodoFechamento() {
			let requisicao = {
				empresa: {...this.empresa},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}				
			this.empresaService.alterarPeriodoFechamento(requisicao)
				.then(resp => {			
					this.diaInicioFechamento = this.empresa.diaInicioFechamento;
					this.diaFinalFechamento = this.empresa.diaFinalFechamento;
					this.atualizarPeriodoFechamento({diaInicioFechamento: this.diaInicioFechamento, diaFinalFechamento: this.diaFinalFechamento});
					this.empresa = {};					
					this.exibirDialogPeriodoFechamento = false;
					exibirMensagem(this, resp);	
                })
                .catch(erro => {exibirMensagem(this, erro)});	
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(30);
			this.permissaoEditar = permissoes.includes(32);				
		}
	},	
	created() {
		this.empresaService = new EmpresaService();			
	},
	mounted() {	
		this.validarPermissoes();	
		this.listar();		
	}
}
</script>

<style scoped>
</style>